export const DisputeTypeStrings = Object.freeze({
  MISSING: 'Missing',
  CONFLICT: 'Conflict',
})
